import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dynamic-privacy-dialog',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="overlay" *ngIf="visible" (click)="close()">
      <div class="dialog" (click)="$event.stopPropagation()">
        <div class="dialog-header">
          <h3>Informativa Privacy</h3>
          <button class="close-btn" (click)="close()">&times;</button>
        </div>
        <div class="dialog-body" [innerHTML]="privacyHtml"></div>
        <div class="dialog-footer">
          <button class="accept-btn" (click)="accept()">Ho letto e accetto</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .overlay {
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background: rgba(0,0,0,0.7);
      z-index: 1000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
    }
    .dialog {
      background: var(--bg-card, #1a1a1a);
      border: 1px solid var(--border, #333);
      max-width: 700px;
      width: 100%;
      max-height: 80vh;
      display: flex;
      flex-direction: column;
    }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      border-bottom: 1px solid var(--border, #333);
      h3 { color: var(--accent, #ffd65b); margin: 0; font-size: 1.2rem; }
      .close-btn {
        background: none;
        border: none;
        color: var(--text-muted, #999);
        font-size: 24px;
        cursor: pointer;
        &:hover { color: var(--text, #fff); }
      }
    }
    .dialog-body {
      padding: 20px;
      overflow-y: auto;
      color: var(--text, #e0e0e0);
      font-size: 14px;
      line-height: 1.6;
    }
    .dialog-footer {
      padding: 15px 20px;
      border-top: 1px solid var(--border, #333);
      text-align: center;
      .accept-btn {
        background: var(--accent, #ffd65b);
        color: var(--bg, #111);
        border: none;
        padding: 12px 30px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        &:hover { filter: brightness(1.1); }
      }
    }
  `],
})
export class DynamicPrivacyDialogComponent {
  @Input() visible = false;
  @Input() privacyHtml = '';
  @Output() accepted = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  accept(): void {
    this.accepted.emit();
  }

  close(): void {
    this.closed.emit();
  }
}
